import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import { ProfessionalReplacementTypes } from '@pharmaplan/common';

import { ChipType } from '../../../helpers/Constants';
import strings from '../../../localization';
import WithSkeleton from '../WithSkeleton';
import CustomChip from '../CustomChip';

import styles from './styles';

interface IReplacementTag {
  successAction: string;
  replacementType?: ProfessionalReplacementTypes;
}

const ReplacementLabels = () =>
  ({
    [ProfessionalReplacementTypes.pharmacist]: strings.pharmacist,
    [ProfessionalReplacementTypes.technician]: strings.technician,
    [ProfessionalReplacementTypes.student]: strings.pharmacyStudent,
  });

const ReplacementTag: FC<IReplacementTag> = ({
  replacementType,
  successAction,
}) => {
  const SkeletonBox = WithSkeleton({
    successAction,
    variant: 'rectangular',
    height: 15,
    width: 90,
  })(Box);

  return (
    <SkeletonBox sx={styles.container}>
      <Typography sx={styles.title}>{strings.replacementType}</Typography>
      <CustomChip
        type={ChipType.replacementType}
        replacementType={replacementType}
        label={
          ReplacementLabels()[
            replacementType ?? ProfessionalReplacementTypes.pharmacist
          ]
        }
      />
    </SkeletonBox>
  );
};
export default ReplacementTag;
